import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito hablar inglés?',
  a: 'No. La IA traduce tus propuestas y el trabajo por vos.'
}, {
  q: '¿Necesito una computadora potente?',
  a: 'No, cualquier notebook que abra un navegador funciona.'
}, {
  q: '¿Cuánto tiempo toma ver resultados?',
  a: 'Si seguís el paso a paso, podés cerrar tu primera tarea en la primera semana.'
}, {
  q: '¿Es legal?',
  a: '100%. Estás prestando un servicio profesional al exterior.'
}, {
  q: '¿Cómo retiro los dólares?',
  a: 'Te enseñamos el sistema exacto para que el dinero llegue a tu cuenta local a valor Blue.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4" data-id="element-34">
      <div className="max-w-3xl mx-auto" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-36">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-37">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-38">
          {faqs.map((faq, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-[#111827] border border-gray-800 rounded-2xl overflow-hidden" data-id="element-39">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-40">
                <span className="font-semibold text-white text-lg pr-4" data-id="element-41">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-emerald-500 transition-transform duration-300 shrink-0 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-42" />
              </button>

              <AnimatePresence data-id="element-43">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-44">
                    <div className="px-6 pb-5 text-gray-400 leading-relaxed border-t border-gray-800/50 pt-4" data-id="element-45">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}